import { Component, input, output, signal, viewChild } from '@angular/core';
import { TableModule } from 'primeng/table';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DatePicker } from 'primeng/datepicker';
import { Button } from 'primeng/button';

@Component({
  selector: 'app-date-picker-component',
  standalone: true,
  imports: [TableModule, CommonModule, FormsModule, Button, DatePicker],
  templateUrl: './date-picker-component.html',
  styleUrl: './date-picker-component.scss',
})
export class DatePickerComponent {
  mainDatePicker = viewChild.required<DatePicker>('mainDatePicker');

  rangeDates = signal<Date[]>([new Date(), new Date()]);
  selectedDateRange = signal<string>('today');

  showShortCutButtons = input<boolean>(true);

  onCancelEvent = output<null>();
  onChangeEvent = output<Date[]>();

  dateRanges = [
    { label: 'Today', value: 'today' },
    { label: 'Yesterday', value: 'yesterday' },
    { label: 'This week', value: 'this_week' },
    { label: 'Last week', value: 'last_week' },
    { label: 'This month', value: 'this_month' },
    { label: 'Last month', value: 'last_month' },
  ];

  setDateRange(range: string) {
    this.selectedDateRange.set(range);
    const today = new Date();

    switch (range) {
      case 'today':
        this.rangeDates.set([today, today]);
        break;
      case 'yesterday':
        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);
        this.rangeDates.set([yesterday, yesterday]);
        break;
      case 'this_week':
        const thisWeekStart = new Date(today);
        thisWeekStart.setDate(today.getDate() - today.getDay());
        this.rangeDates.set([thisWeekStart, today]);
        break;
      case 'last_week':
        const lastWeekStart = new Date(today);
        lastWeekStart.setDate(today.getDate() - today.getDay() - 7);
        const lastWeekEnd = new Date(today);
        lastWeekEnd.setDate(today.getDate() - today.getDay() - 1);
        this.rangeDates.set([lastWeekStart, lastWeekEnd]);
        break;
      case 'this_month':
        const thisMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
        this.rangeDates.set([thisMonthStart, today]);
        break;
      case 'last_month':
        const lastMonthStart = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        const lastMonthEnd = new Date(today.getFullYear(), today.getMonth(), 0);
        this.rangeDates.set([lastMonthStart, lastMonthEnd]);
        break;
    }

    this.onChange(this.rangeDates());
  }

  onChange(event: any) {
    if (event[0] && event[1]) {
      this.onChangeEvent.emit(this.rangeDates());

      setTimeout(() => {
        this.mainDatePicker().hideOverlay();
      }, 500);
    }
  }

  onChangeDateRangeBy(days: number) {
    const currentStartDate = new Date(this.rangeDates()[0]);
    const currentEndDate = new Date(this.rangeDates()[1]);

    const startDate = new Date(currentStartDate.setDate(currentStartDate.getDate() + days));
    const endDate = new Date(currentEndDate.setDate(currentEndDate.getDate() + days));
    this.rangeDates.set([startDate, endDate]);
    this.onChange(this.rangeDates());
  }

  cancel() {
    this.rangeDates.set([new Date(), new Date()]);
    this.mainDatePicker()?.hideOverlay();
    this.onCancelEvent.emit(null);
  }
}
